import { combineReducers } from "redux";
import { changePassword, twoFactorData, notificationData, tokensData } from "./reducer";

export default combineReducers({
  changePassword,
  twoFactorData,
  notificationData,
  tokensData
});
